module.exports = "/_next/static/images/expertiseBg-04a86ce1e7f2f6daa9e811613cbf440a.webp";